import type { TypeBrandLogo } from "@bmi/contentful-types";

export const brands: TypeBrandLogo[] = [
  "AeroDek",
  "BMI",
  "BMIAcademyEN",
  "BMIAcademyDE",
  "BRAAS",
  "BRAMAC",
  "Canopia",
  "Cementegola",
  "ChovA",
  "Cobert",
  "Coverland",
  "Esha",
  "Everguard",
  "Everlite",
  "icopal",
  "icopalKatto",
  "icopalVedag",
  "Klober",
  "Monarflex",
  "Monarplan",
  "MONIER",
  "Necoflex",
  "Ormax",
  "Redland",
  "RoofPro",
  "RoofProServiceTeam",
  "Sealoflex",
  "SereniCoperture",
  "Siplast",
  "Sunscape",
  "VEDAG",
  "VILLAS",
  "Wierer",
  "WOLFIN",
  "Zanda"
];
